const SelectField = (props) => {
  const {
    label,
    name,
    tabIndex,
    grid_length,
    itens,
    value,
    onChange,
    readOnly = false,
  } = props;
  return (
    <>
      <label className='col-sm-4 col-form-label' htmlFor='licensePlate'>
        {label}
      </label>
      <div className={`col-sm-${grid_length}`}>
        <select
          tabIndex={tabIndex}
          name={name}
          className='form-control'
          disabled={readOnly}
          onChange={onChange}
          value={value || ""}>
          <option value=''>--{label}--</option>
          {itens &&
            itens.map((item, index) => (
              <option key={item.key} value={item.id}>
                {item.name}
              </option>
            ))}
        </select>
      </div>
    </>
  );
};
export default SelectField;
